module.exports = __webpack_public_path__ + "media/christmas-bells.b1f98de2.ogg";